import { useState } from 'react';
import cn from 'classnames';

import { NextPageBtn } from '../../components/NextPageBtn/NextPageBtn';
import { Sections } from '../../types/Sections';

import './Advantages.scss';
import { Icons } from '../../components/Icons/Icons';
import { getTranslation } from '../../constants/translations';

export const Advantages = () => {
  const t = getTranslation();
  const [openedArticle, setOpenedArticle] = useState<number | null>(null);

  const toggleArticle = (i: number) => {
    if (i === openedArticle) {
      setOpenedArticle(null);
    } else {
      setOpenedArticle(i);
    }
  };

  return (
    <section className="advantages main__advantages" id={Sections.ADVANTAGES}>
      <div className="advantages__container">
        <div className="advantages__content-wrapper">
          <h2 className="advantages__title">{t.ADVANTAGES.title}</h2>

          {t.ADVANTAGES.articles.map((article, i) => (
            <article
              className="advantages__content"
              onClick={() => toggleArticle(i)}
              key={article.title}
            >
              <div className="advantages__content-title">
                {article.title}{' '}
                <Icons
                  name="arrow-short"
                  customClassName={cn('advantages__content-title-arrow', {
                    'advantages__content-title-arrow--shown':
                      i === openedArticle,
                  })}
                />
              </div>
              <p
                className={cn('advantages__text', {
                  'advantages__text--shown': i === openedArticle,
                })}
              >
                {article.body}
              </p>
            </article>
          ))}
        </div>

        <div className="advantages__next-btn-wrapper">
          <NextPageBtn
            sectionId={Sections.SIXINTIX}
            btnText={t.COMMON.secondNextPageBtn}
            customClassName="advantages__next-btn"
          />
        </div>
      </div>
    </section>
  );
};
